// extracted by mini-css-extract-plugin
export default {"modalContainer":"yy","fadeRight":"zy","fadeUp":"Ay","topShelf":"By","newFlavorBadge":"Cy","transparentText":"Ey","cancelButton":"Fy","invisibleLink":"Gy","closeIcon":"Hy","linkContainer":"Iy","hed":"Jy","image":"Ky"};
    if(module.hot) {
      // 1730991502695
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  